import React from 'react'
import { RiCheckboxMultipleFill } from 'react-icons/ri'
import Select from 'react-select';


export default function Dashboard() {

    const options = [
        { value: 'Short Answer', label: 'Last Two Days' },
        { value: 'Paragraph', label: 'Last Week' },
        { value: 'Multiple Choice', label: 'Last Month' },
        { value: 'Last Year', label: 'Last Year' },
        
    ]



    return (
        <div className='mt-5 pt-5 mx-3 px-5 w-100'>
            <div style={{
                borderRadius: '10px',
                width: '100%'
            }} className=' mt-4 mx-3 p-lg-5 p-3 bg-light w-100'>

            <div className='d-flex justify-content-end'>
            <Select className='w-25' options={options} />

            </div>

                <div className='row'>
                    <div className='col-lg-3 p-3 col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3 col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3 col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3 col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3 col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3  col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3  col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3  col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3  col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3  col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3  col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                    <div className='col-lg-3 p-3  col-md-4 col-sm-6 col-12'>
                        <div style={{
                            borderRadius: '10px'
                        }} className='d-flex bg-info-subtle justify-content-center p-3 flex-column'>

                            <RiCheckboxMultipleFill className='fs-3 mx-auto my-2' />
                            <h1 className='mx-auto'>0000</h1>
                            <p className='mx-auto'>Trainings Data</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
